// extracted by mini-css-extract-plugin
export default {"shadowed":"Imprint_shadowed__otkRH","pink":"Imprint_pink__dFCKV","green":"Imprint_green__HDaVo","skills":"Imprint_skills__O1XPL"};